import "../Stylesheets/Aside/Aside.css"
import { Link, NavLink } from "react-router-dom"
import { Bell, ChatLeftDots, Hammer, House, Mouse, People, PersonLock, Eye, Trophy } from "react-bootstrap-icons"
import { useSelector } from "react-redux"

// One place to define navigation, so a link and its route can't drift apart.
// The previous list included a "/statistics" entry that had no matching route
// and no page — clicking it blanked the content area.
const NAV_ITEMS = [
    { to: "/", label: "Dashboard", Icon: House, end: true },
    { to: "/users", label: "Users", Icon: People },
    { to: "/accounts", label: "Accounts", Icon: PersonLock },
    { to: "/watchlist", label: "Watchlist", Icon: Eye },
    { to: "/bid-history", label: "Bids History", Icon: Hammer },
    { to: "/won-vehicles", label: "Won Cars", Icon: Trophy },
    { to: "/actions-history", label: "Actions History", Icon: Mouse },
    { to: "/alerts", label: "Alerts", Icon: ChatLeftDots, adminOnly: true },
    { to: "/notifications", label: "Notifications", Icon: Bell, adminOnly: true },
];

const Aside = ({ showFullWidth }) => {
    const user = useSelector(state => state.user);
    const items = NAV_ITEMS.filter((item) => !item.adminOnly || user.role === "admin");

    return (
        <div className="aside-modal-content">
            <Link to="/" className="aside-logo-link">
                <img
                    src={showFullWidth ? "/static/icons/logo.png" : "/static/icons/logo-minimized.png"}
                    className={`aside-logo ${showFullWidth ? "" : "aside-logo-minimized"}`}
                    alt="Carspace"
                />
            </Link>
            <div className="navigation-container">
                <nav className="aside-navigation" aria-label="Main">
                    <ul className={`aside-navbar-list ${showFullWidth ? '' : 'minimized-aside'}`}>
                        {items.map(({ to, label, Icon, end }) => (
                            <li key={to}>
                                <NavLink to={to} end={end} title={showFullWidth ? undefined : label}>
                                    <Icon /> <span>{label}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Aside
